function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M56.6253 45.4584V20.3334H17.542V45.4584H56.6253ZM56.6253 6.37508C58.1061 6.37508 59.5263 6.96332 60.5733 8.0104C61.6204 9.05748 62.2087 10.4776 62.2087 11.9584V45.4584C62.2087 46.9392 61.6204 48.3593 60.5733 49.4064C59.5263 50.4535 58.1061 51.0417 56.6253 51.0417H17.542C14.4432 51.0417 11.9587 48.5292 11.9587 45.4584V11.9584C11.9587 10.4776 12.5469 9.05748 13.594 8.0104C14.6411 6.96332 16.0612 6.37508 17.542 6.37508H20.3337V0.791748H25.917V6.37508H48.2503V0.791748H53.8337V6.37508H56.6253ZM46.9382 28.8759L34.5432 41.2709L27.0616 33.7892L30.0207 30.8301L34.5432 35.3526L43.9791 25.9167L46.9382 28.8759ZM6.37532 56.6251H45.4587V62.2084H6.37532C3.27658 62.2084 0.791992 59.6959 0.791992 56.6251V23.1251H6.37532V56.6251Z",
  fill: "#18CDA6"
});

var SvgPrepaymentCalendar = function SvgPrepaymentCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrepaymentCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/prepayment_calendar.40c60de5.svg";
export { ForwardRef as ReactComponent };